<template>
    <div class="invoice-container">
      <!-- 顶部Logo和基本信息 -->
      <div class="flex-row mb-20">
        <div class="left-info">
          <img alt="AWS Logo" class="aws-logo" :src="logo" />
          <div class="account-label">Account number:</div>
          <div class="account-number">{{ accountNumber }}</div>
          <div class="bill-to-label">Bill to Address:</div>
          <div class="bill-to-address">{{ billToAddress }}</div>
        </div>
        <div class="right-info">
          <div class="invoice-title" style="text-align: left">Amazon Web Services, Inc. Invoice</div>
          <div class="invoice-contact" style="text-align: left">
            Email or talk to us about your AWS account or bill, visit aws.amazon.com/contact-us/
            <br />
            Submit feedback on your Invoice Experience
            <a href="#">here</a>
            .
          </div>
          <div>
            <h2 style="margin-bottom: 20px; text-align: left">Invoice Summary</h2>
            <table class="aws-billing-table">
              <tr>
                <td class="label">Invoice Number</td>
                <td class="amount amount-title">{{ invoiceNumber }}</td>
              </tr>
              <tr>
                <td class="label">Invoice Date</td>
                <td class="amount amount-title">{{ invoiceDate }}</td>
              </tr>
              <tr>
                <td class="label">TOTAL AMOUNT DUE ON {{ dueDate }}</td>
                <td class="amount amount-title">{{ totalAmount }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
  
      <div class="section-title">This invoice is for the billing period {{ billingPeriod }}</div>
      <div class="notes">
        Greetings from Amazon Web Services, we're writing to provide you with an electronic invoice for your use of AWS services. Additional
        information about your bill, individual service charge details, and your account history are available on the Account Activity Page.
      </div>
      <div class="invoice-summary">
        <h2 style="margin-bottom: 5px">Billing Summary</h2>
        <table class="aws-billing-table">
          <tr>
            <td class="label label-title">AWS Service Charges</td>
            <td class="amount amount-title">{{ getValue('TotalCharges') }}</td>
          </tr>
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Charges</td>
            <td class="amount">{{ getValue('Charges') }}</td>
          </tr>
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Discount (Bundled Discount)</td>
            <td class="amount negative">{{ getValue('BundledDiscount') }}</td>
          </tr>
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Discount (AWS Distribution Program Discount)</td>
            <td class="amount negative">{{ getValue('DiscountDiscount') }}</td>
          </tr>
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Credits</td>
            <td class="amount">{{ getValue('Credits') }}</td>
          </tr>
          <!-- SavingPlan Negation行，只有当存在数据时才显示 -->
          <tr v-if="getValue('SavingsPlanNegation') && getValue('SavingsPlanNegation') !== '0.00'">
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Savings Plan (Negation)</td>
            <td class="amount negative">{{ getValue('SavingsPlanNegation') }}</td>
          </tr>
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Tax</td>
            <td class="amount">{{ getValue('Tax') }}</td>
          </tr>
          <tr class="total-row">
            <td class="label"><strong>Total for this invoice</strong></td>
            <td class="amount">
              <strong>{{ getValue('Total') }}</strong>
            </td>
          </tr>
        </table>
      </div>
      <!-- Detail Table -->
      <h2 style="margin-bottom: 5px; margin-top: 40px">Detail for Consolidated Bill ({{ accountNumber }})</h2>
      <div v-for="service in serviceList" :key="service.ServiceName" class="service-section">
        <table class="aws-billing-table">
          <!-- 主服务费用行 -->
          <tr>
            <td class="label label-title">{{ service.ServiceName }}</td>
            <td class="amount amount-title">{{ service.body.Total }}</td>
          </tr>
  
          <!-- 费用明细 -->
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Charges</td>
            <td class="amount">{{ service.body.Charges }}</td>
          </tr>
  
          <!-- 折扣行 -->
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Discount (AWS Distribution Program Discount)</td>
            <td class="amount negative">{{ service.body['Discount'] }}</td>
          </tr>
  
          <!-- VAT行 -->
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;VAT</td>
            <td class="amount negative">{{ service.body['Tax'] }}</td>
          </tr>
  
          <!-- 信用额度 -->
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Credits</td>
            <td class="amount">{{ service.body.Credits }}</td>
          </tr>
  
          <!-- SavingsPlan Negation（只有当服务有此数据时才显示） -->
          <tr v-if="service.body.SavingsPlanNegation">
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Savings Plan (Negation)</td>
            <td class="amount negative">{{ service.body.SavingsPlanNegation }}</td>
          </tr>
  
          <!-- 税 -->
          <tr>
            <td class="label">&nbsp;&nbsp;&nbsp;&nbsp;Tax</td>
            <td class="amount">{{ service.body.Tax }}</td>
          </tr>
        </table>
      </div>
      <!-- Notes -->
      <div class="notes">
        * May include estimated US sales tax, VAT, SIT, GST and CT.
        <br />
        Amazon Web Services, Inc. is registered under the Singapore GST Overseas Vendor Registration Pay-Only Regime and GST registration
        number is M90370390E
        <br />
        AWS, Inc. is a "Registered Foreign Supplier" under Japanese Consumption Tax Law and therefore AWS, Inc. is required to declare and pay
        consumption tax in respect of this transaction (as a "Digital Service") to the Japan Tax Authority.
        <br />
        ** This is not a VAT, SIT or GST invoice. Related tax invoices can be accessed by going to the Bills page on your Billing Management
        Console.
        <br />
        ***** Please reference the tax invoice for a breakout of the Canadian taxes by type
        <br />
        # Usage and recurring charges for this statement period will be charged on your next billing date. The amount of your actual charges
        for this statement period may differ from the charges shown on this page. The charges shown on this page do not include any additional
        usage charges accrued during this statement period after the date you are viewing this page. Also, one-time fees and subscription
        charges are assessed separately, on the date that they occur.
        <br />
        All charges and prices are in US Dollars
        <br />
        All AWS Services are sold by Amazon Web Services, Inc.
        <br />
        Amazon Web Services, Inc.'s US Federal Tax Identification Number: is 20-4938068.
      </div>
  
      <!-- Bank Info -->
      <div class="bank-info">
        <b>Electronic funds transfer details:</b>
        <br />
        Account Name: Amazon Web Services, Inc.
        <br />
        Checking Account Number: 4121350227
        <br />
        Wire Routing Number: 121000248
        <br />
        Bank Address:
        <br />
        420 Montgomery Street
        <br />
        San Francisco CA 94104
        <br />
        Bank Name: Wells Fargo NA
        <br />
        ABA Routing Number: 121000248
        <br />
        SWIFT Code: WFBIUS6SXXX
        <br />
        <br />
        or Mail payment to:
        <br />
        Amazon Web Services, Inc.
        <br />
        PO Box 84023
        <br />
        Seattle, WA 98124-8423, US
      </div>
    </div>
  </template>
  
  <script setup>
    import { ref, onMounted } from 'vue'
    import logo from '@/assets/aws-logo.png' // 你的logo图片
    import { getBillInvoice } from '@/api/api'
  
    const props = defineProps({
      linkId: {
        type: String,
        required: true,
      },
      month: {
        type: String,
        required: true,
      },
      billType: {
        type: Number,
        required: true,
      },
    })
  
    const accountNumber = ref('')
    const billToAddress = ref('')
    const invoiceNumber = ref('')
    const invoiceDate = ref('')
    const dueDate = ref('')
    const totalAmount = ref('')
    const billingPeriod = ref('')
    const serviceList = ref([])
    const summaryData = ref({})
  
    const fetchInvoiceData = async () => {
      try {
        console.log('=== Invoice Data Fetch Debug ===')
        console.log('linkId from props:', props.linkId)
        console.log('month from props:', props.month)
        console.log('billType from props:', props.billType)
        console.log('API call parameters:', { 
          id: props.linkId, 
          month: props.month, 
          billType: props.billType 
        })
        
        const res = await getBillInvoice({ 
          id: props.linkId,
          month: props.month,
          billType: props.billType
        })
        console.log('=== API Response ===')
        console.log('Full API response:', res)
        
        if (res.code === 2000) {
          const data = res.data
          accountNumber.value = data.accountNumber
          billToAddress.value = data.billToAddress
          invoiceNumber.value = data.invoiceNumber
          invoiceDate.value = data.invoiceDate
          dueDate.value = data.dueDate
          totalAmount.value = data.totalAmount
          billingPeriod.value = data.billingPeriod
          serviceList.value = data.serviceList
          summaryData.value = data.summaryData
        } else {
          console.error('API returned error code:', res.code)
          console.error('API error message:', res.msg)
          console.error('API error data:', res.data)
        }
      } catch (error) {
        console.error('Failed to fetch invoice data:', error)
      }
    }
  
    onMounted(() => {
      fetchInvoiceData()
    })
  
    const getValue = (propertyName) => {
      return summaryData.value[propertyName] || ''
    }
  </script>
  
  <style scoped>
    .invoice-container {
      width: 100%;
      max-width: 790px;
      margin: 0 auto;
      background: #fff;
      padding: 30px 20px 20px 20px;
      font-size: 14px;
      color: #222;
    }
  
    .flex-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  
    .left-info {
      width: 40%;
    }
  
    .right-info {
      width: 55%;
      text-align: right;
    }
  
    .aws-logo {
      height: 80px;
      margin-bottom: 20px;
    }
  
    .account-label,
    .bill-to-label {
      color: #888;
      font-size: 13px;
      margin-top: 10px;
    }
  
    .account-number {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  
    .bill-to-address {
      white-space: pre-line;
      font-size: 13px;
      margin-bottom: 10px;
    }
  
    .invoice-title {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 6px;
    }
  
    .invoice-contact {
      font-size: 12px;
      color: #666;
      margin-bottom: 10px;
    }
  
    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin-top: 30px;
      margin-bottom: 10px;
      color: #222;
    }
  
    .notes {
      font-size: 12px;
      color: #555;
      margin-top: 10px;
      margin-bottom: 10px;
      line-height: 1.5;
    }
  
    .bank-info {
      font-size: 12px;
      color: #222;
      margin-top: 20px;
      line-height: 1.5;
    }
  
    .mb-20 {
      margin-bottom: 20px;
    }
  
    .invoice-summary-table >>> .el-table__header-wrapper th {
      background-color: transparent;
      color: #000000;
      font-weight: normal;
      border-bottom: 1px solid #ddd;
    }
  
    .invoice-summary-table >>> .el-table__row td {
      padding: 8px 0;
      border-bottom: 1px solid #ddd;
    }
  
    .invoice-summary-table >>> .el-table__row:last-child td {
      border-bottom: none;
    }
  
    .invoice-summary-table >>> .el-table__row .summary-total-label {
      background-color: #eaeaea;
      font-weight: bold;
      color: #333;
    }
  
    .invoice-summary-table >>> .el-table__row .summary-total-value {
      font-weight: bold;
      font-size: 16px;
      color: #333;
    }
  
    .invoice-summary-table >>> .cell {
      padding-left: 0;
      padding-right: 0;
    }
  
    .invoice-summary-table >>> .el-table__cell.gutter {
      display: none !important;
    }
  
    .invoice-summary {
      font-family: Arial, sans-serif;
      max-width: 100%;
      margin: 0;
    }
  
    h2 {
      color: #333;
      font-size: 1.5em;
      margin-bottom: 16px;
    }
  
    .aws-billing-table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 20px;
    }
  
    .aws-billing-table tr:not(.total-row) {
      border-bottom: 2px solid #e0e0e0;
    }
  
    .aws-billing-table tr:last-child {
      border-bottom: none;
    }
  
    .label {
      padding: 8px 0;
      text-align: left;
      color: #333;
    }
  
    .amount {
      padding: 8px 0;
      text-align: right;
      color: #333;
    }
  
    .amount.negative {
      color: #d33;
    }
  
    .total-row {
      border-top: 1px solid #e0e0e0;
      padding-top: 12px;
      background-color: #ceb584;
    }
  
    .label-title {
      color: #ff9900;
      font-weight: bold;
      font-size: 16px;
    }
  
    .amount-title {
      font-weight: bold;
    }
  
    .total-row .label,
    .total-row .amount {
      padding-top: 12px;
      font-size: 1.1em;
    }
  </style>
  